import { Close } from '@audio-network/componentlibrary/icons'
import { StatusToastProps } from './StatusToast.types'
import clsx from 'clsx'
import styles from './Toast.module.css'

const StatusToast = ({
	children,
	toastProps,
	startIcon,
	...props
}: StatusToastProps): JSX.Element => {
	const { ...restProps } = props
	const { type, closeButton, closeToast } = toastProps

	return (
		<div className={clsx(styles.toast, styles[type])} {...restProps}>
			{startIcon && startIcon}
			{children}
			{closeButton && (
				<button onClick={closeToast}>
					<Close />
				</button>
			)}
		</div>
	)
}

export default StatusToast
